import React from 'react'
import Table from '../Table/Table'
import ImageSlider from '../ImageSlider/ImageSlider'
import RichTextComponent from '../../../Components/RichTextComponent/RichTextComponent'
import Titill from '../../../Components/Titill/Titill'
import MyndOgTexti from '../../../Components/MyndOgTexti/MyndOgTexti'
import LitlarMyndir from '../../LitlarMyndir/LitlarMyndir'
import BlarHeading from '../../BlarHeading/BlarHeading'
import LitlarMyndirOgTexti from '../../LitlarMyndirOgTexti/LitlarMyndirOgTexti'

export default function VoruSliceZone(props) {
  const {
    slices,
    prismicCtx
  } = props

  return (
    slices.map((slice, index) => {
      switch (slice.slice_type) {
        case('litlarmyndirogtexti'):
          return <LitlarMyndirOgTexti key={index} slice={slice} prismicCtx={prismicCtx}/>
        case ('blar_heading'):
          return <BlarHeading key={index} slice={slice}/>
        case('litlar_myndir'):
          return <LitlarMyndir key={index} slice={slice}/>
        case('texti_og_mynd'):
          return <MyndOgTexti key={index} slice={slice} prismicCtx={prismicCtx}/>
        case ('tafla_13'):
          return <Table key={index} slice={slice} />
        case ('tafla_5'):
          return <Table key={index} slice={slice} />
        case ('tafla_6'):
          return <Table key={index} slice={slice} />
        case ('tafla_14'):
          return <Table key={index} slice={slice} />
        case ('myndir'):
          return <ImageSlider key={index} slice={slice} />
        case ('rich_text'):
          return <RichTextComponent key={index} data={slice.primary.richtext} prismicCtx={prismicCtx} />
        case ('titill'):
          return <Titill key={index} slice={slice} />
        default:
          return null;
      }
    })
  );
}